import { setUser } from "@sentry/nextjs"
import { observable, runInAction, computed } from "mobx"

import { fetchGetMe } from "~/api/me/get"
import { fetchGetStudentMessageConnectionUnreadMessageConnectionCount } from "~/api/student/message_connection/unread_message_connection_count/get"
import { fetchTestSetting } from "~/api/student/test-setting/get"
import { User } from "~/entities/User"

export default class UserStore {
  @observable user: User | null = null
  @observable requestedFetchGetMe = false
  @observable testPattern: string | null = null

  fetchLoginUser = async (): Promise<User | null> => {
    const data = await fetchGetMe()
    const unreadCountMessageData = await fetchGetStudentMessageConnectionUnreadMessageConnectionCount()
    if (!data.error && !unreadCountMessageData.error) {
      runInAction(() => {
        this.user = new User(data, unreadCountMessageData)
      })
      setUser({ id: `${data.id}` })
    } else {
      setUser({ id: undefined })
    }
    runInAction(() => {
      this.requestedFetchGetMe = true
    })
    return this.user
  }

  fetchUserTestSetting = async (testName: string) => {
    const res = await fetchTestSetting(testName)
    runInAction(() => {
      this.testPattern = res.test_pattern
    })
  }

  @computed
  get authed(): boolean {
    return Boolean(this.user && this.user.id !== undefined)
  }

  @computed
  get authedAsStudent(): boolean {
    return Boolean(this.user && this.user.id !== undefined && this.user.type === "general")
  }

  @computed
  get authedAsCorporate(): boolean {
    return Boolean(this.user && this.user.id !== undefined && this.user.type === "corporate")
  }
}
